import React from "react";
import { studio } from "../../mock";
import { cn } from "../../lib/utils";
import { resolveMedia } from "../../lib/api";
import Block from "./blocks";
import { CtaLink } from "./primitives";

const Hero = ({ hero = {}, onCta }) => (
  <section className="relative overflow-hidden">
    <div className="absolute inset-0">
      <img src={hero.image_url ? resolveMedia(hero.image_url) : studio.images.hero} alt="" className="h-full w-full object-cover grayscale" />
      <div className="absolute inset-0 bg-background/45" />
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-background/10" />
    </div>
    <div className="container-x relative flex min-h-[70vh] flex-col justify-end pb-16 pt-32 lg:min-h-[80vh] lg:pb-24">
      {hero.eyebrow && (
        <p className="eyebrow flex items-center gap-3">
          <span className="inline-block h-px w-8 bg-primary" />
          {hero.eyebrow}
        </p>
      )}
      <h1 className="display mt-5 max-w-5xl text-[clamp(3rem,9vw,9rem)] uppercase leading-[0.84] tracking-wide" data-testid="lp-headline">
        {hero.headline}
      </h1>
      <div className="mt-8 grid gap-6 lg:grid-cols-12 lg:items-end">
        <p className="max-w-xl whitespace-pre-line text-base leading-relaxed text-foreground/80 md:text-lg lg:col-span-7">{hero.subheadline}</p>
        <div className="flex flex-wrap gap-3 lg:col-span-5 lg:justify-end">
          <CtaLink label={hero.cta_label} url={hero.cta_url} onCta={onCta} />
        </div>
      </div>
    </div>
  </section>
);

/**
 * Renders a landing page document. Used by the public /lp/:slug route and the admin live preview.
 */
const LandingRenderer = ({ page, onCta, preview = false }) => {
  if (!page) return null;
  return (
    <div className={cn("bg-background text-foreground", preview && "pointer-events-none select-none")} data-testid="lp-renderer">
      <Hero hero={page.hero} onCta={onCta} />
      {(page.blocks || []).map((block) => (
        <Block key={block.id} block={block} onCta={onCta} slug={page.slug} />
      ))}
      {page.footer_note && (
        <section className="container-x py-10">
          <p className="text-xs leading-relaxed text-muted-foreground">{page.footer_note}</p>
        </section>
      )}
    </div>
  );
};

export default LandingRenderer;
